import type { components } from "../../api/generated/survey-svc";
import type { AuthenticatedUser } from "./model";

type CurrentUserTransport = components["schemas"]["AuthMe"]["currentUser"] & {
  hasPassword?: boolean;
};

export const adaptAuthenticatedUser = (
  user: CurrentUserTransport,
): AuthenticatedUser => ({
  id: user.id,
  name: user.name,
  email: user.email,
  ...(user.hasPassword === undefined ? {} : { hasPassword: user.hasPassword }),
  phone: user.phone,
  birthDate: user.birthDate,
  area: user.area,
  challenges: user.challenges,
  topics: user.topics,
  twoFactorAuthentication: user.twoFactorAuthentication,
  role: user.role,
  jobRole: user.jobRole,
  language: user.language,
  image: user.image,
  company: user.company,
  companyRole:
    user.companyRole === "Owner" ||
    user.companyRole === "Editor" ||
    user.companyRole === "Viewer"
      ? user.companyRole
      : null,
});
